module.exports = __webpack_public_path__ + "697ad1d250ab78dfc8a54f1770ba5645.svg";